import React from "react";

const MobileCancelButton = props => {
  return (
    <button
      className="btn btn-warning btn-lg"
      value={"cancel"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileCancelButton;
